import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const getRecentlyAddedProgramsSeriesMgmt = (
  Condition,
  Status,
  classtype,
  filters,
  locale,
  pageNum,
  pageSize
) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ORGANIZE.GET_RECENTLY_ADDED_PROGRAMS_SERIES_MGMT(
      Condition,
      Status,
      classtype,
      filters,
      locale,
      pageNum,
      pageSize
    ),
    "",
    cancelToken
  );
};

export default getRecentlyAddedProgramsSeriesMgmt;
